import Card from './components/Card';
import Gameboard from './components/Gameboard';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <Gameboard />
    </div>
  );
}

export default App;
